import {
  PillButton,
  Modal,
  Button,
  RecurringDatePicker
} from '@collegebacker/backer-ui/ui'
import { isStarterGiftFlow } from 'modules/contribution/helpers'
import { CurrentFlow, Frequency } from 'modules/contribution/types'
import { getOrdinalNumber } from 'utils'

import styles from './RecurringDatePickerModal.module.scss'

const RecurringDatePickerModal = ({
  flow,
  firstDay,
  setFirstDay,
  secondDay,
  setSecondDay,
  frequency,
  setFrequency,
  showFrequencyPickerModal,
  setShowFrequencyPickerModal,
}: Props) => {
  const frequencyPickerModal = () => {
    return (
      <Modal
        isOpen={showFrequencyPickerModal}
        className={styles.modal}
        isBottomSheet
        onCloseClick={() => setShowFrequencyPickerModal(false)}
      >
        <h3 className='typo-app-title-small'>Select date</h3>
        <RecurringDatePicker
          dafaultValue={[firstDay, secondDay]}
          onChange={(e) => {
            setFirstDay(e.value[0])
            setSecondDay(e.value[1])
            setFrequency(e.isSemimonthly ? 'semimonthly' : 'monthly')
          }}
          semimonthly={frequency === 'semimonthly'}
          showSwitcher={!isStarterGiftFlow(flow)}
        />
        <Button
          onClick={() => setShowFrequencyPickerModal(false)}
          label='Set payment date'
          className={styles.saveBtn}
        />
      </Modal>
    )
  }

  const paymentString =
    frequency === 'semimonthly'
      ? `on the ${getOrdinalNumber(firstDay)} and ${getOrdinalNumber(
          secondDay
        )}`
      : `${getOrdinalNumber(firstDay)} of each month`

  return (
    <>
      {frequencyPickerModal()}
      <PillButton
        label={paymentString}
        icon='chevron-down'
        onClick={() => setShowFrequencyPickerModal(true)}
      />
    </>
  )
}

export default RecurringDatePickerModal

interface Props {
  flow: CurrentFlow
  firstDay: number
  setFirstDay: (arg0: number) => void
  secondDay: number
  setSecondDay: (arg0: number) => void
  frequency: Frequency
  setFrequency: (arg0: 'monthly' | 'semimonthly') => void
  showFrequencyPickerModal: boolean
  setShowFrequencyPickerModal: (arg0: boolean) => void
}
